import { Preferences } from '@capacitor/preferences';
import { Capacitor } from '@capacitor/core';
import { STORAGE_KEYS } from './constants';

// Async versions using Capacitor Preferences (falls back to localStorage on web)
export const storageSetItem = async (key: STORAGE_KEYS, value: string) => {
  await Preferences.set({ key, value });
};

export const storageRemoveItem = async (key: STORAGE_KEYS) => {
  await Preferences.remove({ key });
};

export const storageGetItem = async (key: STORAGE_KEYS): Promise<string | null> => {
  const { value } = await Preferences.get({ key });
  return value;
};

// Sync versions for backward compatibility (will be deprecated)
// These only work on web and should be migrated to async versions
export const storageSetItemSync = (key: STORAGE_KEYS, value: string) => {
  if (!Capacitor.isNativePlatform()) {
    localStorage.setItem(key, value);
  } else {
    console.warn(`storageSetItemSync called on native platform for key: ${key}. Use async version instead.`);
  }
};

export const storageRemoveItemSync = (key: STORAGE_KEYS) => {
  if (!Capacitor.isNativePlatform()) {
    localStorage.removeItem(key);
  } else {
    console.warn(`storageRemoveItemSync called on native platform for key: ${key}. Use async version instead.`);
  }
};

export const storageGetItemSync = (key: STORAGE_KEYS): string | null => {
  if (!Capacitor.isNativePlatform()) {
    return localStorage.getItem(key);
  } else {
    console.warn(`storageGetItemSync called on native platform for key: ${key}. Use async version instead.`);
    return null;
  }
};

// Additional storage keys used in the app
const ADDITIONAL_STORAGE_KEYS = {
  BRAND_REVIEW_SHOWN_STATE: 'brandReviewShownState',
  PWA_SHOWN_STATE: 'progressiveWebAppShownState'
};

// Migration helper: Move data from localStorage to Preferences on native platforms
export const migrateStorageData = async () => {
  if (Capacitor.isNativePlatform()) {
    // List of keys to migrate
    const keysToMigrate = [
      STORAGE_KEYS.REFRESH_TOKEN,
      STORAGE_KEYS.CONVERSATION_METHOD,
      ADDITIONAL_STORAGE_KEYS.BRAND_REVIEW_SHOWN_STATE,
      ADDITIONAL_STORAGE_KEYS.PWA_SHOWN_STATE
    ];

    for (const key of keysToMigrate) {
      try {
        // Check if data exists in localStorage
        const localStorageValue = localStorage.getItem(key);
        if (localStorageValue) {
          // Check if already migrated
          const { value: existingValue } = await Preferences.get({ key });
          if (!existingValue) {
            // Migrate to Preferences
            await Preferences.set({ key, value: localStorageValue });
            // Remove from localStorage after successful migration
            localStorage.removeItem(key);
            console.log(`Migrated ${key} from localStorage to Preferences`);
          }
        }
      } catch (error) {
        console.error(`Failed to migrate ${key}:`, error);
      }
    }
  }
};
